
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.516 19.936a2.237 2.237 0 01-2.235-2.234 2.237 2.237 0 012.235-2.235 2.237 2.237 0 012.234 2.235 2.236 2.236 0 01-2.234 2.234M5.36 12.281a2.217 2.217 0 01-1.56.701c-1.242.004-2.264-.935-2.3-2.167a2.237 2.237 0 012.167-2.3 2.247 2.247 0 011.599.607c.435.41.683.963.7 1.561a2.218 2.218 0 01-.606 1.598M16.516 1.5a2.237 2.237 0 012.234 2.235 2.237 2.237 0 01-2.234 2.235 2.238 2.238 0 01-2.235-2.235A2.238 2.238 0 0116.516 1.5m0 12.467c-1.43 0-2.658.816-3.286 1.997l-6.053-3.699c-.012-.007-.025-.007-.037-.014a3.691 3.691 0 00.327-1.613 3.726 3.726 0 00-.196-1.039l6.223-3.688a3.723 3.723 0 003.022 1.559 3.739 3.739 0 003.734-3.735A3.739 3.739 0 0016.516 0a3.74 3.74 0 00-3.735 3.735c0 .275.035.542.09.801l-6.344 3.76c-.077-.089-.145-.184-.232-.265a3.69 3.69 0 00-2.672-1.015A3.738 3.738 0 00.002 10.86a3.738 3.738 0 003.73 3.623c.038 0 .076 0 .114-.002a3.692 3.692 0 002.446-1.031c.035.032.06.07.103.095l6.41 3.918c-.005.08-.024.157-.024.239a3.738 3.738 0 003.735 3.734 3.738 3.738 0 003.734-3.734 3.738 3.738 0 00-3.734-3.735","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    